import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import { ContactBox, Loader, PageTitle } from 'ui';
import { fetchAnalysts } from 'services';
import { useContact } from 'shared/hooks';
import { contactTypes, contactTargets } from 'shared/constants/contactBox';

const useStyles = makeStyles(theme => ({
  analyst: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(3),
    },
  },
  button: {
    cursor: 'pointer',
  },
  icon: {
    opacity: 0.5,
  },
  form: {
    marginBottom: theme.spacing(2),
  },
}));

const Analysts = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const contact = useContact();
  const [value, setValue] = useState('');
  const [analysts, setAnalysts] = useState([]);
  const [isPending, setIsPending] = useState(true);

  const handleChange = e => {
    setValue(e.target.value);
  };

  const handleClear = () => setValue('');

  const requestAnalysts = ({ query } = {}) =>
    fetchAnalysts({ query })
      .then(({ data }) => {
        setAnalysts(
          data.map(({ analystTeams, firstName, name, jobTitle, followed, userId }) => ({
            analystTeams,
            firstName,
            lastName: name,
            jobTitle,
            followed,
            userId,
          })),
        );
      })
      .then(() => setIsPending(false));

  const handleSubmit = e => {
    e.preventDefault();
    setIsPending(true);
    requestAnalysts({ query: value });
  };

  useEffect(() => {
    requestAnalysts();
  }, []);

  const handleContact = (type, target) => async ({ subject, message, origin }) => {
    contact({ type, subject, message, origin, target });
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={8}>
        <PageTitle>{t('Analysts')}</PageTitle>
        <form onSubmit={handleSubmit} className={classes.form}>
          <TextField
            placeholder={t('Search by name')}
            variant="outlined"
            fullWidth
            onChange={handleChange}
            value={value}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className={classes.icon} />
                </InputAdornment>
              ),
              endAdornment: !value.length ? null : (
                <InputAdornment position="end">
                  <CloseIcon
                    className={`${classes.button} ${classes.icon}`}
                    onClick={handleClear}
                  />
                </InputAdornment>
              ),
            }}
          />
        </form>
        {isPending ? (
          <Loader />
        ) : (
          analysts.map(analyst => (
            <div key={analyst.userId} className={classes.analyst}>
              <ContactBox
                compact
                showMessageButton={false}
                {...analyst}
                onRequestCall={handleContact(contactTypes.CALL, contactTargets.ANALYST)}
                className={classes.analyst}
              />
            </div>
          ))
        )}
      </Grid>
    </Grid>
  );
};

export { Analysts };
